<template lang="html">
  <div class="mng-editor-content">
    <div class="mng-editor-panel">
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          添加标签
        </div>
        <div class="editor-panel-markers">
          <div v-for="labelStyle in labelStyles"
               :key="labelStyle.id"
               class="editor-panel-markers__marker"
               :class="{
                 'editor-panel-markers__marker--selected':
                   labelStyle === selectedLabelStyle
               }"
               @click="onSelectIcon(labelStyle)">
            <img v-if="labelStyle && labelStyle.icon"
                 :src="labelStyle.icon"
                 class="editor-panel-markers__icon">
          </div>
          <div class="editor-panel-markers__marker editor-panel-markers__marker--add">
            <img src="@/assets/views/models/plus.png"
                 class="editor-panel-markers__icon"
                 @click="selectImage">
            <input ref="uploader"
                   type="file"
                   class="editor-panel-markers__uploader"
                   accept="image/*"
                   @change="getNewLabelStyle">
          </div>
        </div>
      </div>
      <div class="mng-editor-panel__block mng-editor-panel__block--last">
        <div class="mng-editor-panel__label">
          标签管理
        </div>
        <div class="editor-panel-list">
          <div class="editor-panel-list__title">
            <span>标签名称</span>
            <span>操作</span>
          </div>
          <div class="editor-panel-list__items">
            <div v-for="(item, index) in labels" :key="index" class="editor-panel-list__item">
              <span>{{ item.label_name }}</span>
              <div class="editor-panel-list__actions">
                <div class="ai-button ai-button--text ai-button--text--primary"
                     @click="showEditDialog(item)">
                  编辑
                </div>
                <div class="ai-button ai-button--text ai-button--text--danger"
                     @click="showDeleteConfirm(item)">
                  删除
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mng-vr-scene">
      <VrScene ref="vrScene"
               class="mng-vr-scene__stage"
               :scene-id="$route.params.modelId"
               @initialized="onInitialized"
               @right-click="onPlaceLabel"
               @label-clicked="onClickLabel"
               @on_shoted='onShoted' />
      <div class="mng-vr-scene__actions">
        <span>右键添加标签</span>
      </div>
    </div>
    <AiDialog class="label-dialog"
              width="441"
              :visible.sync="labelDialogVisible"
              @close="closeDialog">
      <div slot="header" class="label-dialog__header">
        {{ mode === 'edit' ? '编辑标签' : '添加标签' }}
      </div>
      <div class="label-dialog__content">
        <form class="form">
          <div class="form-item">
            <label class="form-item__label">
              对应商品
            </label>
            <div class="form-item__content">
              <div class="item-select">
                <SelectableItem v-for="item in items"
                                :key="item.id"
                                :selected="item.id === label.bound_product_id"
                                :src="item.photos_list | firstImage"
                                mode="default"
                                class="item-select__item"
                                @click="onClickBoundingItem(item.id)" />
              </div>
            </div>
          </div>
          <div class="form-item">
            <label class="form-item__label">
              搭配商品
            </label>
            <div class="form-item__content">
              <div class="item-select">
                <SelectableItem v-for="item in items"
                                :key="item.id"
                                :selected.sync="item.selected"
                                :src="item.photos_list | firstImage"
                                mode="select"
                                class="item-select__item" />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div slot="footer" class="label-dialog__footer">
        <div class="ai-button ai-button--primary"
             :class="{'ai-button--disabled': loading, 'ai-button--disabled--primary': loading}"
             @click="updateLabel">
          确 定
        </div>
        <div class="ai-button" @click="closeDialog">
          取 消
        </div>
      </div>
    </AiDialog>
  </div>
</template>

<script>
import VrScene from '../../../components/ai-vr-scene.vue';
import SelectableItem from '@/components/editor/selectable-item.vue';

export default {
  components: {
    SelectableItem,
    VrScene
  },
  filters: {
    firstImage(imageList) {
      if (!imageList || !imageList.length) return '';
      return imageList[0];
    }
  },
  data() {
    return {
      labelDialogVisible: false,
      loading: false,
      items: [],
      label: {},
      labels: [],
      labelStyles: [],
      selectedLabelStyle: null,
      mode: 'edit'
    };
  },
  computed: {
    wrappedDescription() {
      return this.label.description ? this.label.description.split('\n') : [];
    }
  },
  mounted() {
  },
  methods: {
    onLabelLoad({ labels }) {
      this.labels = labels;
    },
    onInitialized() {
      this.loadLabelIcons();
      this.loadLabelPositions();
      this.loadPanoramaIcons();
    },
    async loadPanoramaIcons() {
      const { data: { data: { panorama_icons: panoramaIcons } } } = await this.$http.post(
        '/v1/list-brand-panorama-icons',
        { store_id: this.$route.params.modelId }
      );
      this.$refs.vrScene.setPanoramaIcons(panoramaIcons);
    },
    async loadLabelIcons() {
      const { data: { data: labelStyles } } = await this.$http.post(
        '/v1/list-brand-label-icons',
        { store_id: this.$route.params.modelId }
      );
      this.labelStyles = labelStyles;
      this.$refs.vrScene.setLabelIcons(labelStyles);
    },
    async loadLabelPositions() {
      const { data: { data: { labels } } } = await this.$http.post(
        '/v1/list-label-coordinates?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
        { store_id: this.$route.params.modelId }
      );
      this.labels = labels;
      this.$refs.vrScene.setLabelPositions(labels.map((label) => {
        const l = { coordinate: {} };
        l.coordinate.positionX = label.coordinate.position_x;
        l.coordinate.positionY = label.coordinate.position_y;
        l.coordinate.positionZ = label.coordinate.position_z;
        l.coordinate.directionX = label.coordinate.direction_x;
        l.coordinate.directionY = label.coordinate.direction_y;
        l.coordinate.directionZ = label.coordinate.direction_z;
        l.coordinate.id = label.coordinate.id;
        l.panoramaId = label.panorama_id;
        l.iconId = label.icon_id;
        l.id = label.id;
        return l;
      }));
    },
    async onPlaceLabel({ pos, direction, panoramaId }) {
      if (!this.selectedLabelStyle) return;
      this.mode = 'create';
      this.labelDialogVisible = true;

      await this.loadItems();
      this.label = {
        position_x: pos.x,
        position_y: pos.y,
        position_z: pos.z,
        direction_x: direction.x,
        direction_y: direction.y,
        direction_z: direction.z,
        panorama_id: Number(panoramaId),
        store_id: this.$route.params.modelId, // TODO
        bound_product_id: this.items && this.items.length ? this.items[0].id : null,
        icon_id: this.selectedLabelStyle.id
      };
      this.selectedLabelStyle = null;
    },
    onSelectIcon(labelStyle) {
      if (labelStyle !== this.selectedLabelStyle) {
        this.selectedLabelStyle = labelStyle;
        this.$refs.vrScene.startLabelPlacing(labelStyle.id);
      } else {
        this.selectedLabelStyle = null;
        this.$refs.vrScene.cancelLabelPlacing();
      }
    },
    onClickBoundingItem(id) {
      this.label.bound_product_id = id;
    },
    async showEditDialog(label) {
      this.mode = 'edit';
      this.labelDialogVisible = true;
      try {
        const { data: { data } } = await this.$http.post(
          '/admin/get-label-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            label_id: label.id
          }
        );
        this.label = data;
        this.loadItems();
      } catch (error) {
        this.$log(error.error_msg || error);
        this.labelDialogVisible = false;
      }
    },
    showDeleteConfirm(label) {
      this.$confirm({
        title: '警 告',
        message: '确认要删除该标签吗?'
      }).then(() => {
        this.deleteLabel(label);
      }).catch(() => {});
    },
    async addLabel() {
      this.label.related_products_ids = this.items.filter(i => i.selected).map(i => i.id);
      try {
        const { data } = await this.$http.post(
          '/admin/add-label?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          this.label
        );
        if (data.error_no === 200) {
          this.$message('添加成功');
          // this.$refs.vrScene.loadLabel();
          this.loadLabelPositions();
          this.closeDialog();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async deleteLabel(label) {
      try {
        const { data } = await this.$http.post(
          '/admin/delete-label?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            label_id: label.id
          }
        );
        if (data.error_no === 200) {
          this.$message('删除成功');
          // this.$refs.vrScene.loadLabel();
          this.loadLabelPositions();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async loadItems() {
      try {
        const { data: { data: { data } } } = await this.$http.post(
          '/admin/list-products?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId
          }
        );
        this.items = data.map((item) => {
          const result = {};
          if (this.label.related_products) {
            result.selected = !!this.label.related_products.find(p => p.id === item.id);
          } else {
            result.selected = false;
          }
          Object.assign(result, item);
          return result;
        });
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async updateLabel() {
      if (this.mode === 'create') {
        this.addLabel();
        return;
      }
      try {
        const { data } = await this.$http.post(
          '/admin/modify-label?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            label_id: this.label.id,
            related_products_ids: this.items.filter(i => i.selected).map(i => i.id),
            bound_product_id: this.label.bound_product_id
          }
        );
        if (data.error_no === 200) {
          this.closeDialog();
          this.$message('更新成功');
          // this.$refs.vrScene.loadLabel();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    closeDialog() {
      this.label = {};
      this.labelDialogVisible = false;
    },
    onContextMenu() {},
    onClickLabel({ labelId }) {
      this.$refs.vrScene.getCurrentShot(200,200,200,200);
      this.showEditDialog({ id: labelId });
    },
    onShoted(event){
      //document.body.appendChild(event.image);
      console.log(event);
    },
    selectImage() {
      this.$refs.uploader.click();
    },
    getNewLabelStyle() {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.createLabelStyle(fileReader.result);
      }, false);
      const file = this.$refs.uploader.files[0];
      if (file) fileReader.readAsDataURL(file);
    },
    async createLabelStyle(image) {
      try {
        const { data } = await this.$http.post(
          '/admin/add-label-icon?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            label_icon: image.replace(/data:image.*?,/gi, '')
          }
        );
        if (data.error_no === 200) {
          this.$message('添加成功');
          this.$refs.vrScene.loadPanoramaIcons();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    onLoadedLabelStyle({ labelStyle }) {
      this.labelStyles = labelStyle;
    }
  }
};
</script>

<style lang="scss" scoped>
.editor-panel-markers {
  display: flex;

  &__marker {
    height: 28px;
    width: 28px;
    border-radius: 2px;
    background-color: #d8d8d8;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    cursor: pointer;

    &--add {
      background-color: transparent;
      border: 1px solid #999;
      height: 26px;
      width: 26px;
    }

    img {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }

    &--selected {
      border: 2px solid #a9a9a9;
      height: 24px;
      width: 24px;
    }
  }

  &__uploader {
    visibility: hidden;
    position: absolute;
    height: 0;
    width: 0;
    display: inline-block;
  }
}

.editor-panel-list {
  height: 350px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;

  &__title {
    display: grid;
    background-color: #e5e5e5;
    grid-template-columns: 50% 50%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;
    color: #666;
    user-select: none;
  }

  &__items {
    overflow-y: scroll;
    flex: 1;
  }

  &__item {
    display: grid;
    background-color: #fff;
    grid-template-columns: 50% 50%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;
    border-bottom: 1px solid #e5e5e5;

    span {
      color: #666;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  &__actions .ai-button {
    margin: 0 6px;
  }
}

.label-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }

  &__content {
    display: flex;
    padding: 20px 16px;
  }

  &__footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .ai-button {
      width: 59px;
      height: 26px;
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

.form {
  display: inline-block;
}

.form-item {
  margin-bottom: 20px;
  width: 100%;
  display: flex;

  &:last-child {
    margin-bottom: 0;
  }

  &__label {
    display: inline-flex;
    width: 70px;
    color: #6c6c6c;
    font-size: 14px;
    height: 28px;
    align-items: center;
    flex-direction: row-reverse;
    user-select: none;
  }

  &__content {
    display: inline-block;
    margin-left: 12px;

    .ai-input-wrapper {
      width: 327px;
      height: 28px;
    }

    textarea {
      width: 327px;
      height: 80px;
      font-size: 12px;
    }
  }
}

.item-select {
  width: 295px;
  height: 144px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .2);
  border-radius: 4px;
  padding: 16px;
  overflow-y: scroll;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;

  &__item {
    width: 58px;
    height: 58px;
  }
}

.preview {
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 10px;
  padding: 20px 0;
  border: 1px solid #979797;
  background-color: #d8d8d8;
}

.item-info {
  min-width: 272px;
  min-height: 288px;
  text-align: right;
  color: #fff;
  filter: drop-shadow(0 2px 2px #000);
  user-select: none;
  pointer-events: none;

  &__title {
    font-size: 26px;
    line-height: 40px;
    border-bottom: 2px solid #fff;
  }

  &__text {
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;
  }
}
</style>
